import { Expense } from "../../expense/expense";
import { Category } from "../../category/category";

export class responseAddExpense {
    category:Category;
    expense:Expense;
    stats:any;
    constructor (data) {
        this.category = data.category;
        this.expense = data.expense;
        this.stats = data.stats;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-add-expense.ts